<template>
  <div id="footer" class="bg-dark">
    <div class="view-wrap">
      <section class="show-minimal minimal text-center">
        <p class="fine-print-lg">&copy;{{year}} TunnelBear LLC.</p>
      </section>
      <section class="not-minimal smaller">
        <div class="section-inner">
          <div class="container">
            <div class="footer-content">
              <div class="footer-column">
                <h6>RememBear</h6>
                <ul>
                  <li><a :href="external.help">Help</a></li>
                  <li><a :href="ENV.blogURL">Blog</a></li>
                </ul>
              </div>
              <div class="footer-column">
                <h6>Company</h6>
                <ul>
                  <li><router-link :to="{ name: 'privacy-policy'}">Privacy Notice</router-link></li>
                  <li><router-link :to="{ name: 'terms-of-service'}">Terms of Service</router-link></li>
                </ul>
              </div>
              <div class="footer-column">
                <h6>Follow Us</h6>
                <ul class="horizontal">
                  <li>
                    <a :href="external.facebookUrl" class="icon-parent">
                      <i class="icon icon-facebook">
                        <span>Facebook</span>
                      </i>
                    </a>
                  </li>
                  <li>
                    <a :href="external.instagramUrl" class="icon-parent">
                      <i class="icon icon-instagram">
                        <span>Instagram</span>
                      </i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div id="essentials" class="text-center">
              <h6>Get the Bear Essentials</h6>
              <div class="apps">
                <a class="dark" href="https://www.tunnelbear.com" aria-label="TunnelBear website">
                  <div class="app">
                    <img src="./images/tunnelbear-app.svg" alt="TunnelBear">
                    <span>TunnelBear</span>
                  </div>
                </a>
              </div>
            </div>
            <div id="signature" class="text-center">
              <img src="~@/images/remembear-logo.svg" alt="RememBear">
              <p>&copy;{{year}} TunnelBear&nbsp;LLC.</p>
              <p>Grizzly regards from Toronto,&nbsp;Canada</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'site-footer',
  data () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>

<style scoped lang="stylus" src="./footer.styl" >



// WEBPACK FOOTER //
// src/components/footer/footer.vue